import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=51dfcf96&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=51dfcf96&prod&lang=scss&scoped=true"
import style1 from "./PageHeader.vue?vue&type=style&index=1&id=51dfcf96&prod&lang=scss&scoped=true"
import style2 from "./PageHeader.vue?vue&type=style&index=2&id=51dfcf96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dfcf96",
  null
  
)

export default component.exports